class HeroSection {
  render() {
    const section = document.createElement('section');
    section.className = 'hero';

    section.innerHTML = `
     <div class="inner-hero d-flex align-items-center justify-content-center">
          <div class="container-app text-center d-flex flex-column gap-2">
               <div class="d-flex align-items-center justify-content-center">
                    <a href="#/cekmakanan" class="d-flex text-decoration-none flex-row py-2 px-3 bg-warning-subtle rounded-4 hero-btn">
                         <p class="d-flex flex-row gap-2 text-warning small m-0">Coba Sekarang
                              <span>
                                   <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12.9996 10.9999L3.49964 20.4999M14.0181 3.53838C15.2361 4.34658 16.4068 5.29941 17.5008 6.3934C18.6042 7.49683 19.564 8.67831 20.3767 9.90766M9.2546 7.89605L6.37973 6.93776C6.04865 6.8274 5.68398 6.89763 5.41756 
                                        7.12306L2.56041 9.54065C1.97548 10.0356 2.14166 10.9775 2.86064 11.2424L5.56784 12.2398M11.6807 18.3524L12.6781 21.0596C12.943 21.7786 13.8849 21.9448 14.3798 21.3599L16.7974 18.5027C17.0228 18.2363 17.0931 17.8716 16.9827 17.5405L16.0244 
                                        14.6657M19.3482 2.27063L14.4418 3.08838C13.9119 3.17668 13.426 3.43709 13.0591 3.82932L6.446 10.8985C4.73185 12.7308 4.77953 15.5924 6.55378 17.3667C8.32803 19.1409 11.1896 19.1886 13.022 17.4744L20.0911 
                                        10.8614C20.4834 10.4944 20.7438 10.0085 20.8321 9.47869L21.6498 4.57222C21.8754 3.21858 20.7019 2.04503 19.3482 2.27063Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                   </svg>
                              </span>
                         </p>
                    </a>
               </div>
               <h1 class="fw-bold fs-1">
                    Kenali Masakan Indonesia dengan Sekali Foto
               </h1>
               <p class="text-secondary">
                    Teknologi AI yang membantu Anda mengidentifikasi hidangan nusantara
               </p>
               <div class="d-flex gap-3 justify-content-center">
                    <a href="#/tentang" class="btn btn-light text-black">Pelajari Lebih Lanjut</a>
                    <a href="#/cekmakanan" class="btn btn-warning">Mulai Cek Makanan</a>
               </div>
          </div>
     </div>`;
    return section;
  }
}

export default HeroSection;
